import { useState } from "react";
export type PublicProfile = {
  did: string;
  handle: string;
  displayName?: string;
  avatar?: string;
};
export function ProfileAvatar({ actor }: { actor: PublicProfile }) {
  const [failed, setFailed] = useState(false);
  let avatar: string | undefined;
  try {
    const url = new URL(actor.avatar ?? "");
    if (url.protocol === "https:") avatar = url.href;
  } catch {
    /* Missing/invalid photos use the initial below. */
  }
  return avatar && !failed ? (
    <img
      className="profile-avatar"
      src={avatar}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  ) : (
    <span className="profile-avatar profile-avatar-fallback" aria-hidden="true">
      {Array.from(
        (actor.displayName || actor.handle).trim(),
      )[0]?.toUpperCase() ?? "?"}
    </span>
  );
}
